import { ICON_GROUP } from './enums';
import type { IconType } from '../@types';

export const SPORTS_ICON_NAMES = [
  'badminton',
  'baseball',
  'basketball',
  'boxing',
  'cricket',
  'darts',
  'esports',
  'floorball',
  'futsal',
  'golf',
  'handball',
  'ice_hockey',
  'mma',
  'rugby_league',
  'snooker',
  'soccer',
  'table_tennis',
  'tennis',
  'volleyball',
  'water_polo',
  'american_football',
  'archery',
  'archery_shooting',
  'aussie_rules',
  'bandy',
  'beach_soccer',
  'beach_volleyball',
  'bowls',
  'chess',
  'cycling',
  'field_hockey',
  'formula_1',
  'gaelic_football',
  'greyhounds',
  'horse_racing',
  'kabaddi',
  'lacrosse',
  'netball',
  'pistol_shooting',
  'rugby_union',
  'shooting',
  'squash',
  'trotting',
] as const;

export const JACKPOT_ICON_NAMES = ['bronze', 'silver', 'gold', 'platinum', 'diamond'] as const;
export type CasinoJackpotIconName = (typeof JACKPOT_ICON_NAMES)[number];
export const CASINO_JACKPOT_ICON_NAMES: readonly CasinoJackpotIconName[] = [...JACKPOT_ICON_NAMES].reverse();

export const getIconNamesByType = (type: IconType) => {
  switch (type) {
    case ICON_GROUP.SPORTS:
      return SPORTS_ICON_NAMES;
    case ICON_GROUP.JACKPOT:
      return JACKPOT_ICON_NAMES;
    case ICON_GROUP.CASINO_JACKPOT:
      return CASINO_JACKPOT_ICON_NAMES;
    default:
      return [];
  }
};
